import React from "react";
import SectionHeader from "../core/style/SectionHeader";
import StudentTable from "../core/StudentTable";

const Section = props => {
  return (
    <>
      <SectionHeader>{props.title}</SectionHeader>
      {props.data[props.name].length > 0 ? (
        <StudentTable headers={props.headers} data={props.data[props.name]} />
      ) : (
        <p>No {props.title}.</p>
      )}
    </>
  );
};

export default Section;
